import type { ComponentPropsWithoutRef } from 'react';
import Link from 'next/link';
import { LinkProps } from 'next/link';

import clsx from 'clsx';

const baseStyle = 'rounded' as const;

const focusRing =
    'focus:outline-none focus:ring-2 focus:ring-offset-2 dark:ring-offset-icoDarkMode-deepBlack/80 focus:ring-icoBlue-200 rounded' as const;

export type LinkBasePropsType = LinkProps &
    Omit<ComponentPropsWithoutRef<'a'>, 'href'> & {
        disableFocusRing?: boolean;
    };

const LinkBase = ({
    children,
    disableFocusRing,
    href,
    className,
    ...restProps
}: LinkBasePropsType) => {
    // Prevent Next.js error when href is undefined or invalid
    if (!href) {
        return (
            <span
                className={clsx(baseStyle, { [focusRing]: !disableFocusRing }, className)}
                {...(restProps as Omit<
                    typeof restProps,
                    'prefetch' | 'replace' | 'scroll' | 'shallow' | 'passHref' | 'legacyBehavior'
                >)}>
                {children}
            </span>
        );
    }

    return (
        <Link
            href={href}
            className={clsx(baseStyle, { [focusRing]: !disableFocusRing }, className)}
            {...restProps}>
            <>{children}</>
        </Link>
    );
};

export default LinkBase;
